export const DEFAULT_CURRENCY = 'EUR'
